import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  useAddTodoMutation,
  useGetTodosQuery,
  useDeleteTodoMutation,
} from "../../redux/slices/productApiSlice";

import {
  useAddsTodoMutation,
  useGetsTodosQuery,
  useDeleteeTodoMutation,
} from "../../redux/slices/todoApiSlice";

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FaRegHeart,
  FaHeart,
  FaSearch,
  FaFilter,
  FaShoppingCart,
  FaExclamationTriangle,
  FaCheckCircle,
  FaRedo,
  FaSpinner,
  FaBoxOpen,
  FaTrash,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";

import { useGetCatagoryQuery } from "../../redux/slices/catagoryApiSlice";
import { setCatagory } from "../../redux/slices/catagorySlice";

const Products = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // =========================================================
  // MUTATIONS
  // =========================================================

  const [addTodo] = useAddTodoMutation();
  const [deleteTodo] = useDeleteTodoMutation();

  const [addTodoo] = useAddsTodoMutation();
  const [deleteeTodo] = useDeleteeTodoMutation();

  // =========================================================
  // STATE
  // =========================================================

  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [priceRange, setPriceRange] = useState("all");
  const [inStock, setInStock] = useState("all");

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [productsLoading, setProductsLoading] = useState(true);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [productsError, setProductsError] = useState("");

  const [addingCartId, setAddingCartId] = useState(null);
  const [addingFavoriteId, setAddingFavoriteId] = useState(null);

  const [reloadKey, setReloadKey] = useState(0);
  const [showFilters, setShowFilters] = useState(false);

  // =========================================================
  // AUTH
  // =========================================================

  const { userInfo } = useSelector(
    (state) => state.auth
  );

  // =========================================================
  // CATEGORY
  // =========================================================

  const {
    data: categoryData,
    isLoading: categoryLoading,
    isError: categoryIsError,
    refetch: refetchCategories,
  } = useGetCatagoryQuery();

  // =========================================================
  // CART
  // =========================================================

  const { data: cartData } = useGetTodosQuery();

  const cartItems =
    cartData?.todos ||
    cartData?.allTodos ||
    cartData ||
    [];

  // =========================================================
  // FAVORITES
  // =========================================================

  const { data: favoriteData } =
    useGetsTodosQuery();

  const favoriteItems =
    favoriteData?.todos ||
    favoriteData?.allTodos ||
    favoriteData ||
    [];

  // =========================================================
  // ERROR
  // =========================================================

  const getErrorMessage = (
    error,
    fallback = "Xəta baş verdi."
  ) => {
    if (!error) return fallback;

    if (typeof error === "string") {
      return error;
    }

    if (error?.data?.message) {
      return error.data.message;
    }

    if (error?.data?.error) {
      return error.data.error;
    }

    if (error?.message) {
      return error.message;
    }

    if (error?.status === "FETCH_ERROR") {
      return "Serverə qoşulmaq mümkün olmadı.";
    }

    if (error?.status === 404) {
      return "Məlumat tapılmadı.";
    }

    if (error?.status === 401) {
      return "Bu əməliyyat üçün giriş etməlisiniz.";
    }

    return fallback;
  };

  // =========================================================
  // GET PRODUCT ID
  // =========================================================

  const getItemProductId = (item) => {
    const id =
      item?.productId?._id ||
      item?.productId ||
      item?.product?._id ||
      item?.qolbaq?._id ||
      item?.qolbaqId?._id ||
      item?.qolbaqId ||
      item?.qolbaq_id;

    return id ? String(id) : null;
  };

  // =========================================================
  // CART
  // =========================================================

  const isProductInCart = (productId) => {
    if (!productId) return false;

    return cartItems.some(
      (item) =>
        getItemProductId(item) ===
        String(productId)
    );
  };

  const getCartItem = (productId) => {
    if (!productId) return null;

    return (
      cartItems.find(
        (item) =>
          getItemProductId(item) ===
          String(productId)
      ) || null
    );
  };

  // =========================================================
  // FAVORITE
  // =========================================================

  const isProductInFavorite = (productId) => {
    if (!productId) return false;

    return favoriteItems.some(
      (item) =>
        getItemProductId(item) ===
        String(productId)
    );
  };

  // =========================================================
  // DUPLICATE
  // =========================================================

  const getDuplicateActionMessage = (
    error
  ) => {
    const message =
      error?.data?.message ||
      error?.data?.error ||
      error?.message ||
      "";

    const lowerMessage =
      String(message).toLowerCase();

    if (
      lowerMessage.includes("duplicate") ||
      lowerMessage.includes("already") ||
      lowerMessage.includes("artıq") ||
      lowerMessage.includes("mövcuddur")
    ) {
      return "Bu məhsul artıq mövcuddur.";
    }

    return null;
  };

  // =========================================================
  // CATEGORY
  // =========================================================

  useEffect(() => {
    if (categoryData?.allCatagory) {
      dispatch(
        setCatagory(categoryData.allCatagory)
      );
    }
  }, [categoryData, dispatch]);

  // =========================================================
  // FETCH PRODUCTS
  // =========================================================

  useEffect(() => {
    let cancelled = false;

    const fetchProducts = async () => {
      try {
        if (page === 1) {
          setProductsLoading(true);
        } else {
          setLoadMoreLoading(true);
        }

        setProductsError("");

        const baseUrl =
          process.env.REACT_APP_API_BASE_URL;

        const url = userInfo?._id
          ? `${baseUrl}/api/qolbaq/${userInfo._id}?page=${page}`
          : `${baseUrl}/api/qolbaq?page=${page}`;

        const response =
          await axios.get(url);

        if (cancelled) return;

        const newProducts =
          response?.data?.allQolbaq || [];

        const totalPages =
          Number(
            response?.data?.totalPages
          ) || 1;

        if (page === 1) {
          setProducts(newProducts);
        } else {
          setProducts((prev) => {
            const existingIds =
              new Set(
                prev.map((item) =>
                  String(item._id)
                )
              );

            const uniqueProducts =
              newProducts.filter(
                (item) =>
                  item?._id &&
                  !existingIds.has(
                    String(item._id)
                  )
              );

            return [
              ...prev,
              ...uniqueProducts,
            ];
          });
        }

        setHasMore(
          page < totalPages
        );
      } catch (error) {
        if (cancelled) return;

        console.error(
          "Məhsullar yüklənərkən xəta:",
          error
        );

        setProductsError(
          getErrorMessage(
            error,
            "Məhsulları yükləmək mümkün olmadı."
          )
        );
      } finally {
        if (!cancelled) {
          setProductsLoading(false);
          setLoadMoreLoading(false);
        }
      }
    };

    fetchProducts();

    return () => {
      cancelled = true;
    };
  }, [
    page,
    userInfo?._id,
    reloadKey,
  ]);

  // =========================================================
  // RETRY
  // =========================================================

  const handleRetry = () => {
    setProductsError("");
    setProducts([]);
    setPage(1);
    setHasMore(true);
    setReloadKey((prev) => prev + 1);
  };

  // =========================================================
  // LOAD MORE
  // =========================================================

  const handleLoadMore = () => {
    if (
      loadMoreLoading ||
      productsLoading ||
      !hasMore
    ) {
      return;
    }

    setPage((prev) => prev + 1);
  };

  // =========================================================
  // CART ACTION
  // =========================================================

  const handleAddToCart = async (
    product
  ) => {
    if (!product?._id) {
      toast.error(
        "Məhsul məlumatı tapılmadı."
      );
      return;
    }

    const productId =
      String(product._id);

    if (addingCartId === productId) {
      return;
    }

    setAddingCartId(productId);

    try {
      const alreadyInCart =
        isProductInCart(productId);

      if (alreadyInCart) {
        const cartItem =
          getCartItem(productId);

        if (!cartItem?._id) {
          toast.error(
            "Səbət məlumatı tapılmadı."
          );
          return;
        }

        await deleteTodo(
          cartItem._id
        ).unwrap();

        toast.success(
          "Məhsul səbətdən silindi."
        );

        return;
      }

      if (
        Number(product?.stock) <= 0
      ) {
        toast.error(
          "Bu məhsul hazırda stokda yoxdur."
        );
        return;
      }

      await addTodo({
        productId,
      }).unwrap();

      toast.success(
        "Məhsul səbətə əlavə edildi."
      );
    } catch (error) {
      console.error(
        "Səbət əməliyyatı:",
        error
      );

      const duplicateMessage =
        getDuplicateActionMessage(
          error
        );

      if (duplicateMessage) {
        toast.info(
          duplicateMessage
        );
      } else {
        toast.error(
          getErrorMessage(
            error,
            "Səbət əməliyyatı zamanı xəta baş verdi."
          )
        );
      }
    } finally {
      setAddingCartId(null);
    }
  };

  // =========================================================
  // FAVORITE ACTION
  // =========================================================

  const handleAddToFavorite =
    async (product) => {
      if (!product?._id) {
        toast.error(
          "Məhsul məlumatı tapılmadı."
        );
        return;
      }

      const productId =
        String(product._id);

      if (
        addingFavoriteId ===
        productId
      ) {
        return;
      }

      setAddingFavoriteId(
        productId
      );

      try {
        const alreadyFavorite =
          isProductInFavorite(
            productId
          );

        if (alreadyFavorite) {
          const favoriteItem =
            favoriteItems.find(
              (item) =>
                getItemProductId(
                  item
                ) === productId
            );

          if (!favoriteItem?._id) {
            toast.error(
              "Seçilmiş məhsul məlumatı tapılmadı."
            );
            return;
          }

          await deleteeTodo(
            favoriteItem._id
          ).unwrap();

          toast.success(
            "Məhsul seçilmişlərdən silindi."
          );

          return;
        }

        await addTodoo({
          productId,
        }).unwrap();

        toast.success(
          "Məhsul seçilmişlərə əlavə edildi."
        );
      } catch (error) {
        console.error(
          "Favorite əməliyyatı:",
          error
        );

        const duplicateMessage =
          getDuplicateActionMessage(
            error
          );

        if (duplicateMessage) {
          return;
        }

        toast.error(
          getErrorMessage(
            error,
            "Seçilmişlər əməliyyatı zamanı xəta baş verdi."
          )
        );
      } finally {
        setAddingFavoriteId(
          null
        );
      }
    };

  // =========================================================
  // FILTER
  // =========================================================

  const filteredProducts =
    products.filter((product) => {
      const title =
        product?.title?.toLowerCase() ||
        "";

      const search =
        searchTerm
          .toLowerCase()
          .trim();

      const matchesSearch =
        title.includes(search);

      const matchesCategory =
        selectedCategory ===
        "all" ||
        product?.catagory ===
        selectedCategory;

      const matchesPrice =
        priceRange === "all" ||
        (priceRange === "low" &&
          Number(product?.price) <=
          50) ||
        (priceRange === "mid" &&
          Number(product?.price) >
          50 &&
          Number(product?.price) <=
          150) ||
        (priceRange === "high" &&
          Number(product?.price) >
          150);

      const matchesStock =
        inStock === "all" ||
        (inStock === "inStock" &&
          Number(product?.stock) >
          0) ||
        (inStock === "outOfStock" &&
          Number(product?.stock) ===
          0);

      return (
        matchesSearch &&
        matchesCategory &&
        matchesPrice &&
        matchesStock
      );
    });

  // =========================================================
  // IMAGE
  // =========================================================

  const getProductImage = (
    product
  ) => {
    if (
      Array.isArray(product?.photo)
    ) {
      return product.photo[0];
    }

    return product?.photo;
  };

  // =========================================================
  // PRICE
  // =========================================================

  const formatPrice = (price) => {
    const numericPrice =
      Number(price) || 0;

    return `${numericPrice.toLocaleString(
      "az-AZ",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )} ₼`;
  };

  // =========================================================
  // RESET
  // =========================================================

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("all");
    setPriceRange("all");
    setInStock("all");
  };

  // =========================================================
  // ACTIVE FILTERS
  // =========================================================

  const activeFilterCount =
    [
      selectedCategory !== "all",
      priceRange !== "all",
      inStock !== "all",
    ].filter(Boolean).length;

  // =========================================================
  // CATEGORIES
  // =========================================================

  const categories =
    categoryData?.allCatagory || [];

  // =========================================================
  // LOADING
  // =========================================================

  if (
    productsLoading &&
    page === 1
  ) {
    return (
      <div className="min-h-screen bg-[#07090d] px-2.5 py-3 sm:px-5 sm:py-5">

        <div className="mx-auto max-w-[1800px]">

          <div className="mb-3 flex items-center justify-between">
            <div className="h-7 w-32 animate-pulse rounded-lg bg-slate-800" />

            <div className="h-9 w-9 animate-pulse rounded-xl bg-slate-800" />
          </div>

          <div className="mb-3 h-11 animate-pulse rounded-2xl bg-slate-900" />

          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">

            {Array.from({
              length: 12,
            }).map((_, index) => (
              <div
                key={index}
                className="overflow-hidden rounded-[20px] border border-slate-800 bg-slate-900"
              >
                <div className="aspect-[0.88] animate-pulse bg-slate-800" />

                <div className="space-y-2 p-2.5">
                  <div className="h-3 w-16 animate-pulse rounded bg-slate-800" />
                  <div className="h-7 animate-pulse rounded bg-slate-800" />
                  <div className="h-8 animate-pulse rounded-xl bg-slate-800" />
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    );
  }

  // =========================================================
  // ERROR
  // =========================================================

  if (
    productsError &&
    page === 1
  ) {
    return (
      <div className="min-h-screen bg-[#07090d] px-4 py-10 text-white">

        <div className="mx-auto flex min-h-[60vh] max-w-md items-center justify-center">

          <div className="w-full rounded-[28px] border border-red-500/20 bg-[#10141b] p-7 text-center shadow-2xl">

            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-red-500/10 text-red-500">
              <FaExclamationTriangle className="text-2xl" />
            </div>

            <h2 className="mt-5 text-lg font-black">
              Məhsullar yüklənmədi
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-400">
              {productsError}
            </p>

            <button
              type="button"
              onClick={handleRetry}
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-xs font-black text-slate-900"
            >
              <FaRedo />
              Yenidən yoxla
            </button>

          </div>
        </div>
      </div>
    );
  }

  // =========================================================
  // MAIN
  // =========================================================

  return (
    <div className="min-h-screen bg-[#f4f5f7] text-slate-900 dark:bg-[#07090d] dark:text-white">

      <div className="mx-auto w-full max-w-[1800px] px-2.5 py-3 sm:px-4 sm:py-5 lg:px-6">

        {/* ================================================= */}
        {/* TOP BAR */}
        {/* ================================================= */}

        <div className="mb-3 flex items-center gap-2">

          <div className="flex min-w-0 flex-1 items-center gap-2">

            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#11151c] text-white dark:bg-white dark:text-black">
              <FaBoxOpen className="text-sm" />
            </div>

            <div className="min-w-0">

              <div className="flex items-center gap-2">

                <h1 className="truncate text-base font-black tracking-tight sm:text-lg">
                  Məhsullar
                </h1>

                <span className="rounded-md bg-slate-200 px-1.5 py-0.5 text-[9px] font-black text-slate-500 dark:bg-slate-800 dark:text-slate-400">
                  {filteredProducts.length}
                </span>

              </div>

              <p className="truncate text-[9px] font-medium text-slate-400">
                Sizin üçün seçilmiş məhsullar
              </p>

            </div>
          </div>

          <button
            type="button"
            onClick={() =>
              setShowFilters(
                (prev) => !prev
              )
            }
            className={`relative flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border transition ${showFilters ||
              activeFilterCount > 0
              ? "border-slate-900 bg-slate-900 text-white dark:border-white dark:bg-white dark:text-black"
              : "border-slate-200 bg-white text-slate-600 dark:border-slate-800 dark:bg-[#10141b] dark:text-slate-300"
              }`}
          >
            <FaFilter className="text-xs" />

            {activeFilterCount >
              0 && (
                <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[8px] font-black text-white">
                  {activeFilterCount}
                </span>
              )}
          </button>

        </div>

        {/* ================================================= */}
        {/* SEARCH BAR */}
        {/* ================================================= */}

        <div className="mb-3 flex gap-2">

          <div className="relative min-w-0 flex-1">

            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] text-slate-400" />

            <input
              type="text"
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(
                  e.target.value
                )
              }
              placeholder="Məhsul axtar..."
              className="h-10 w-full rounded-xl border border-slate-200 bg-white pl-8 pr-9 text-[11px] font-semibold text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-slate-400 dark:border-slate-800 dark:bg-[#10141b] dark:text-white dark:focus:border-slate-600"
            />

            {searchTerm && (
              <button
                type="button"
                onClick={() =>
                  setSearchTerm("")
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] text-slate-400 hover:text-red-500"
              >
                <FaTimes />
              </button>
            )}

          </div>

        </div>

        {/* ================================================= */}
        {/* FILTER PANEL */}
        {/* ================================================= */}

        {showFilters && (
          <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-[#10141b]">

            <div className="grid grid-cols-1 divide-y divide-slate-100 dark:divide-slate-800 sm:grid-cols-3 sm:divide-x sm:divide-y-0">

              <div className="p-3">

                <label className="mb-1.5 block text-[9px] font-black uppercase tracking-wider text-slate-400">
                  Kateqoriya
                </label>

                <div className="relative">

                  <select
                    value={
                      selectedCategory
                    }
                    onChange={(e) =>
                      setSelectedCategory(
                        e.target.value
                      )
                    }
                    className="h-9 w-full appearance-none rounded-lg border border-slate-200 bg-slate-50 px-2.5 pr-7 text-[10px] font-bold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-white"
                  >
                    <option value="all">
                      Bütün kateqoriyalar
                    </option>

                    {categories.map(
                      (
                        category,
                        index
                      ) => {
                        const value =
                          typeof category ===
                            "string"
                            ? category
                            : category?.name ||
                            category?.catagory ||
                            category?.title ||
                            "";

                        if (!value) {
                          return null;
                        }

                        return (
                          <option
                            key={
                              category?._id ||
                              index
                            }
                            value={value}
                          >
                            {value}
                          </option>
                        );
                      }
                    )}
                  </select>

                  <FaChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[8px] text-slate-400" />

                </div>
              </div>

              <div className="p-3">

                <label className="mb-1.5 block text-[9px] font-black uppercase tracking-wider text-slate-400">
                  Qiymət
                </label>

                <div className="relative">

                  <select
                    value={priceRange}
                    onChange={(e) =>
                      setPriceRange(
                        e.target.value
                      )
                    }
                    className="h-9 w-full appearance-none rounded-lg border border-slate-200 bg-slate-50 px-2.5 pr-7 text-[10px] font-bold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-white"
                  >
                    <option value="all">
                      Bütün qiymətlər
                    </option>

                    <option value="low">
                      0 – 50 ₼
                    </option>

                    <option value="mid">
                      50 – 150 ₼
                    </option>

                    <option value="high">
                      150 ₼+
                    </option>
                  </select>

                  <FaChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[8px] text-slate-400" />

                </div>
              </div>

              <div className="p-3">

                <label className="mb-1.5 block text-[9px] font-black uppercase tracking-wider text-slate-400">
                  Stok
                </label>

                <div className="relative">

                  <select
                    value={inStock}
                    onChange={(e) =>
                      setInStock(
                        e.target.value
                      )
                    }
                    className="h-9 w-full appearance-none rounded-lg border border-slate-200 bg-slate-50 px-2.5 pr-7 text-[10px] font-bold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-white"
                  >
                    <option value="all">
                      Hamısı
                    </option>

                    <option value="inStock">
                      Stokda olanlar
                    </option>

                    <option value="outOfStock">
                      Stokda olmayanlar
                    </option>
                  </select>

                  <FaChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[8px] text-slate-400" />

                </div>
              </div>

            </div>

            <div className="flex items-center justify-between border-t border-slate-100 px-3 py-2.5 dark:border-slate-800">

              <span className="text-[9px] font-bold text-slate-400">
                {filteredProducts.length} nəticə
              </span>

              <button
                type="button"
                onClick={resetFilters}
                className="text-[9px] font-black text-slate-500 hover:text-red-500"
              >
                Təmizlə
              </button>

            </div>
          </div>
        )}

        {/* ================================================= */}
        {/* CATEGORY ERROR */}
        {/* ================================================= */}

        {categoryIsError && (
          <div className="mb-3 flex items-center justify-between rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 dark:border-amber-900/40 dark:bg-amber-950/20">

            <div className="flex items-center gap-2">

              <FaExclamationTriangle className="text-xs text-amber-500" />

              <span className="text-[10px] font-bold text-amber-700 dark:text-amber-300">
                Kateqoriyalar yüklənmədi
              </span>

            </div>

            <button
              type="button"
              onClick={() =>
                refetchCategories()
              }
              className="rounded-lg bg-amber-500 px-2 py-1 text-[9px] font-black text-white"
            >
              Yenilə
            </button>

          </div>
        )}

        {/* ================================================= */}
        {/* PRODUCT GRID */}
        {/* ================================================= */}

        {filteredProducts.length >
          0 ? (
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7">

            {filteredProducts.map(
              (product) => {
                const productId =
                  String(
                    product?._id
                  );

                const image =
                  getProductImage(
                    product
                  );

                const isInCart =
                  isProductInCart(
                    productId
                  );

                const isFavorite =
                  isProductInFavorite(
                    productId
                  );

                const cartLoading =
                  addingCartId ===
                  productId;

                const favoriteLoading =
                  addingFavoriteId ===
                  productId;

                const stock =
                  Number(
                    product?.stock
                  ) || 0;

                const discountApplied =
                  product?.discountApplied ===
                  true ||
                  Number(
                    product?.discount
                  ) > 0 ||
                  Boolean(
                    product?.oldPrice
                  ) ||
                  Boolean(
                    product?.originalPrice
                  );

                const originalPrice =
                  product?.originalPrice ||
                  product?.oldPrice;

                return (
                  <article
                    key={productId}
                    className={`group relative overflow-hidden rounded-[20px] border transition-all duration-300 ${isInCart
                      ? "border-emerald-500/40 bg-[#0d1714] shadow-[0_10px_35px_rgba(16,185,129,0.08)]"
                      : "border-slate-200 bg-white shadow-[0_5px_25px_rgba(15,23,42,0.06)] hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(15,23,42,0.12)] dark:border-slate-800 dark:bg-[#0d1117]"
                      }`}
                  >

                    {/* ================================================= */}
                    {/* IMAGE AREA */}
                    {/* ================================================= */}

                    <div
                      onClick={() =>
                        navigate(
                          `/product/${productId}`
                        )
                      }
                      className="relative aspect-[0.88] cursor-pointer overflow-hidden bg-slate-100 dark:bg-[#141922]"
                    >

                      {image ? (
                        <img
                          src={image}
                          alt={
                            product?.title ||
                            "Məhsul"
                          }
                          loading="lazy"
                          className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                          onError={(e) => {
                            e.currentTarget.style.display =
                              "none";
                          }}
                        />
                      ) : (
                        <div className="flex h-full w-full items-center justify-center text-slate-300 dark:text-slate-700">
                          <FaBoxOpen className="text-3xl" />
                        </div>
                      )}

                      {/* IMAGE GRADIENT */}

                      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/5 to-transparent" />

                      {/* TOP LEFT */}

                      <div className="absolute left-2 top-2 flex flex-col items-start gap-1">

                        {discountApplied && (
                          <span className="rounded-md bg-red-500 px-1.5 py-1 text-[8px] font-black tracking-wide text-white shadow-lg">
                            ENDİRİM
                          </span>
                        )}

                        {isInCart && (
                          <span className="flex items-center gap-1 rounded-md bg-emerald-500 px-1.5 py-1 text-[8px] font-black text-white shadow-lg">
                            <FaCheckCircle />
                            SƏBƏTDƏ
                          </span>
                        )}

                      </div>

                      {/* FAVORITE */}

                      <button
                        type="button"
                        disabled={
                          favoriteLoading
                        }
                        onClick={(e) => {
                          e.stopPropagation();

                          handleAddToFavorite(
                            product
                          );
                        }}
                        className={`absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full border backdrop-blur-xl transition-all ${isFavorite
                          ? "border-red-500/30 bg-red-500 text-white shadow-lg shadow-red-500/20"
                          : "border-white/20 bg-black/30 text-white hover:bg-white hover:text-red-500"
                          }`}
                      >
                        {favoriteLoading ? (
                          <FaSpinner className="animate-spin text-[10px]" />
                        ) : isFavorite ? (
                          <FaHeart className="text-[11px]" />
                        ) : (
                          <FaRegHeart className="text-[11px]" />
                        )}
                      </button>

                      {/* CATEGORY */}

                      <div className="absolute bottom-2 left-2 right-2">

                        <div className="mb-1 text-[8px] font-black uppercase tracking-[0.12em] text-white/60">
                          {product?.catagory ||
                            "MƏHSUL"}
                        </div>

                        <h3 className="h-8 overflow-hidden text-[12px] font-black leading-4 text-white sm:text-[13px]">
                          {product?.title ||
                            "Adsız məhsul"}
                        </h3>

                      </div>

                    </div>

                    {/* ================================================= */}
                    {/* BOTTOM */}
                    {/* ================================================= */}

                    <div className="p-2 sm:p-2.5">

                      <div className="flex items-end justify-between gap-2">

                        {/* PRICE */}

                        <div className="min-w-0">

                          {discountApplied &&
                            originalPrice && (
                              <div className="truncate text-[8px] font-bold text-slate-400 line-through">
                                {formatPrice(
                                  originalPrice
                                )}
                              </div>
                            )}

                          <div className="truncate text-[16px] font-black tracking-tight text-slate-900 dark:text-white sm:text-[17px]">
                            {formatPrice(
                              product?.price
                            )}
                          </div>

                        </div>

                        {/* STOCK */}

                        <div className="shrink-0">

                          {stock > 0 ? (
                            <span className="rounded-md bg-emerald-50 px-1.5 py-1 text-[8px] font-black text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400">
                              {stock} ədəd
                            </span>
                          ) : (
                            <span className="rounded-md bg-red-50 px-1.5 py-1 text-[8px] font-black text-red-500 dark:bg-red-500/10 dark:text-red-400">
                              Tükənib
                            </span>
                          )}

                        </div>

                      </div>

                      {/* ACTION ROW */}

                      <div className="mt-2 flex gap-1.5">

                        {/* DETAILS */}

                        <button
                          type="button"
                          onClick={() =>
                            navigate(
                              `/product/${productId}`
                            )
                          }
                          className="flex h-8 min-w-0 flex-1 items-center justify-center rounded-lg border border-slate-200 bg-slate-50 text-[9px] font-black text-slate-600 transition hover:bg-slate-100 dark:border-slate-800 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700"
                        >
                          Ətraflı
                        </button>

                        {/* CART */}

                        <button
                          type="button"
                          disabled={
                            cartLoading ||
                            (!isInCart &&
                              stock <= 0)
                          }
                          onClick={() =>
                            handleAddToCart(
                              product
                            )
                          }
                          className={`flex h-8 w-9 shrink-0 items-center justify-center rounded-lg transition ${isInCart
                            ? "bg-emerald-500 text-white hover:bg-red-500"
                            : stock <= 0
                              ? "cursor-not-allowed bg-slate-100 text-slate-300 dark:bg-slate-800 dark:text-slate-600"
                              : "bg-slate-900 text-white hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
                            }`}
                          aria-label={
                            isInCart
                              ? "Səbətdən sil"
                              : "Səbətə əlavə et"
                          }
                        >
                          {cartLoading ? (
                            <FaSpinner className="animate-spin text-[10px]" />
                          ) : isInCart ? (
                            <FaTrash className="text-[10px]" />
                          ) : (
                            <FaShoppingCart className="text-[11px]" />
                          )}
                        </button>

                      </div>

                    </div>

                  </article>
                );
              }
            )}

          </div>
        ) : (


          <div className="flex min-h-[55vh] items-center justify-center px-4 py-10">

            <div className="relative w-full max-w-sm overflow-hidden rounded-[30px] border border-slate-200 bg-white px-6 py-10 text-center shadow-[0_15px_50px_rgba(15,23,42,0.06)] dark:border-slate-800 dark:bg-[#10141b] dark:shadow-none">

              {/* Soft decorative circles */}

              <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-violet-500/10 blur-2xl" />

              <div className="pointer-events-none absolute -bottom-10 -left-10 h-28 w-28 rounded-full bg-blue-500/10 blur-2xl" />

              {/* Cute icon */}

              <div className="relative mx-auto mb-5 flex h-24 w-24 items-center justify-center">

                <div className="absolute inset-0 rounded-full bg-slate-100 dark:bg-slate-800" />

                <div className="relative flex h-[68px] w-[68px] rotate-[-4deg] items-center justify-center rounded-[22px] border border-slate-200 bg-white text-4xl shadow-lg dark:border-slate-700 dark:bg-[#171c25]">

                  🛍️

                </div>

                {/* little sparkle */}

                <span className="absolute right-0 top-1 text-lg">
                  ✨
                </span>

                <span className="absolute bottom-1 left-1 text-sm">
                  💫
                </span>

              </div>

              {/* Title */}

              <h3 className="relative text-lg font-black tracking-tight text-slate-900 dark:text-white">
                Məhsul yoxdur 😐
              </h3>

              {/* Description */}

              <p className="relative mx-auto mt-2 max-w-[280px] text-xs leading-5 text-slate-400 dark:text-slate-500">
                Hazırda göstəriləcək məhsul tapılmadı.
                Axtarış və ya filter seçimlərini dəyişərək
                yenidən cəhd edin.
              </p>

              {/* Button */}

              <button
                type="button"
                onClick={resetFilters}
                className="relative mt-6 inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-slate-900 px-5 text-[11px] font-black text-white shadow-lg shadow-slate-900/10 transition hover:-translate-y-0.5 hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
              >
                <FaRedo className="text-[10px]" />

                Filtrləri təmizlə
              </button>

            </div>

          </div>
        )}

        {/* ================================================= */}
        {/* LOAD MORE */}
        {/* ================================================= */}

        {filteredProducts.length >
          0 &&
          hasMore && (
            <div className="mt-5 flex justify-center">

              <button
                type="button"
                onClick={
                  handleLoadMore
                }
                disabled={
                  loadMoreLoading
                }
                className="flex h-10 min-w-[150px] items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-5 text-[10px] font-black text-slate-700 shadow-sm transition hover:border-slate-300 disabled:opacity-50 dark:border-slate-800 dark:bg-[#10141b] dark:text-white"
              >
                {loadMoreLoading ? (
                  <>
                    <FaSpinner className="animate-spin" />
                    Yüklənir...
                  </>
                ) : (
                  "Daha çox göstər"
                )}
              </button>

            </div>
          )}

        {/* ================================================= */}
        {/* NO MORE */}
        {/* ================================================= */}

        {filteredProducts.length >
          0 &&
          !hasMore && (
            <div className="mt-5 flex items-center justify-center gap-2 text-[9px] font-bold text-slate-400">
              <FaCheckCircle className="text-emerald-500" />
              Bütün məhsullar göstərilir
            </div>
          )}

        {/* ================================================= */}
        {/* BACKGROUND LOADING */}
        {/* ================================================= */}

        {productsLoading &&
          page > 1 && (
            <div className="mt-4 flex items-center justify-center gap-2 text-[10px] font-bold text-slate-400">
              <FaSpinner className="animate-spin" />
              Məhsullar yüklənir...
            </div>
          )}

      </div>
    </div>
  );
};

export default Products;